export default function (data, props) {
    if(data.onair && data.onair[0]) {
        props.title = data.onair[0]['nome_programma'];
        props.content = data.onair[0]['dj-in-onda'];
        props.imageUrl = data.onair[0]['immagineXL'];
    }
}